import * as wixFullstoryLoader from 'wix-fullstory-loader';
import biLogger from 'web-bi-logger';
const trgBi = biLogger.factory({endpoint: 'trg'}).setDefaults({src: 2}).logger();

export function initFullstory() {
  wixFullstoryLoader({
    label: 'marketing-homepage',
    spec: 'specs.marketing.HomepageFullstory',
    onReady: sessionUrl => {
      window.trackJs && window.trackJs.addMetadata('fullsotryUrl', sessionUrl);
      trgBi.log({
        evid: 44,
        fullstoryurl: sessionUrl,
      });
    },
  });
}
